"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrateDailyHotelMemberSchema = exports.MigrateDailyHotelMemberInputSchema = exports.DailyHotelMigrationStatusSchema = void 0;
var zod_1 = require("zod");
exports.DailyHotelMigrationStatusSchema = zod_1.z.object({
    migrationStatusCode: zod_1.z.enum(['NONE', 'IN_PROGRESS', 'COMPLETED']).optional(),
});
exports.MigrateDailyHotelMemberInputSchema = zod_1.z.object({
    token: zod_1.z.string(),
});
exports.MigrateDailyHotelMemberSchema = zod_1.z.string();
